import React from "react";

const SvgShotGlass = props => (
  <svg viewBox="0 0 215 215" {...props}>
    <path
      d="M160 172.7l6.2-130.4H48.8s6.1 126 6.3 130.4H160zM58.6 51.6h97.7l-3.6 83.8H62.3l-3.7-83.8z"
      fill="currentColor"
    />
  </svg>
);

export default SvgShotGlass;